<template>
  <teleport to="body">
    <div class="absolute rounded-10" :style="style" />
  </teleport>
</template>

<script>
import { defineComponent, nextTick, onBeforeUnmount, ref, watch } from 'vue'

export default defineComponent({
  props: {
    id: String
  },

  setup (props) {
    const style = ref(null)
    const lastEl = ref(null)

    watch(() => props.id, (newValue, oldValue) => {
      nextTick(() => {
        lastEl.value = newValue

        if (oldValue) removeOverlay(oldValue)

        setOverlay(newValue)
      })
    }, { immediate: true })

    onBeforeUnmount(() => {
      removeOverlay(lastEl.value)
    })

    function removeOverlay (el) {
      const oldEl = document.getElementById(el)
      oldEl.style.boxShadow = null
      oldEl.style.background = ''
      oldEl.style.borderRadius = ''
      oldEl.style.zIndex = ''
      oldEl.style.border = ''
    }

    function setOverlay (newValue) {
      const el = document.getElementById(newValue)

      if (el) {
        el.style.borderRadius = '8px'
        el.style.border = 'none'
        el.style.zIndex = 10
        el.style.background = 'var(--primary)'
        el.style.boxShadow = 'inset var(--link-color) 0px 0px 0px 3px, rgb(0 0 0 / 35%) 0px 0px 0px 4000px'

        if (newValue === 'menu-items') {
          el.style.padding = '5px 15px'
          el.style.margin = '-8px -15px 0 0'
        }
      }
    }

    return {
      // ref
      // data
      style
      // computed
      // function
    }
  }
})
</script>
